import React from 'react';
import { Outlet } from 'react-router-dom';

import '../../Mobile.css';
function Diet() {

  return (
    <>
      <Outlet />
    </>
  );
}

export default Diet;